import Vue from 'vue'
import App from './App.vue'
import router from './router';

import './icons';


Vue.config.productionTip = false

Vue.router = router;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
